import { render } from "./Metrics_old.vue?vue&type=template&id=1f99f791"
import script from "./Metrics_old.vue?vue&type=script&lang=js"
export * from "./Metrics_old.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__